import React from 'react'
import styled from '@emotion/styled'
import { DefaultCellContentWrapper } from 'view/components/datagrid/renderers'

const ContentWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
`

const StatusText = styled(DefaultCellContentWrapper)`
  font-weight: bold !important;
`

const StatusIndicator = styled.div<{ color: string }>`
  height: 100%;
  flex: 0 0 6px;
  background-color: ${props => props.color};
`

interface StatusCellProps {
  text: string
  color: string
  tooltip: string | string[]
}

export class StatusCell extends React.PureComponent<StatusCellProps> {
  render() {
    const { color, text } = this.props

    return (
      <ContentWrapper>
        <StatusIndicator color={color} />
        <StatusText>{text}</StatusText>
      </ContentWrapper>
    )
  }
}
